import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
import { BaseService } from '../../services/base.service';
import { SharedService } from "../../services/sharedService";

@Injectable()
export class MapService extends BaseService{

  constructor(public http: HttpClient, public sharedService: SharedService){
    super(http, sharedService);
  }

  getRegistered$(bbox, filter){
    return this.http.get(
      this.sharedService.apiUrl('map/feature/registered', '?bbox='+ bbox + (filter ? `&${filter}` : '')))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }
  getWithAttributes$(bbox){
    return this.http.get(
      this.sharedService.apiUrl('map/feature/withattributes', '?bbox='+ bbox))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getNearestBuildings$(latlng){
    return this.http.get(
      this.sharedService.apiUrl('map/feature/nearest', '?latlng='+ latlng))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getFeatureList$(bbox, nolimit = false, nopins = false){
    return this.http.get(
      this.sharedService.apiUrl('map/feature', '?bbox='+ bbox + (nolimit ? '&nolimit=true': '') + (nopins ? '&nopins=true' : '')))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getLayer$(layer, bbox, parentId = null){
    return this.http.get(
      this.sharedService.apiUrl(`map/layer/${layer}`, `?bbox=${bbox}`+ (parentId ? '&parentId=' + parentId : '')))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getLayerFeatureById$(id){
    return this.http.get(
      this.sharedService.apiUrl(`map/layer/feature/${id}`))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getFeatureById$(id){
    return this.http.get(
      this.sharedService.apiUrl('map/feature/' + id, ''))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getTinsByBuildingId$(id):Observable<any>{
    return this.http.get(
      this.sharedService.apiUrl('map/feature/building-tin-balance/' + id, ''))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  upsertBuilding$(body):Observable<any>{
    if (!body.id)
      return this.http.post<any>(this.sharedService.apiUrl('map/building'), body)
        .pipe(
          catchError(error => this.sharedService.handleError(error))
        );
    else
      return this.http.put<any>(this.sharedService.apiUrl(`map/building/${body.id}`), body)
        .pipe(
          catchError(error => this.sharedService.handleError(error))
        );
  }

  addBuilding$(body): Observable<any> {
    return this.http.post<any>(this.sharedService.apiUrl('map/building'), body)
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  updateBuilding$(id, body): Observable<any> {
    return this.http.put<any>(this.sharedService.apiUrl(`map/building/${id}`), body)
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  deleteBuilding$(id): Observable<any> {
    return this.http.delete<any>(this.sharedService.apiUrl(`map/building/${id}`))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  deleteBuildingAttributes$(id): Observable<any> {
    return this.http.delete<any>(this.sharedService.apiUrl(`map/building/attributes/${id}`))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  deleteFeatureAttributes$(id): Observable<any> {
    return this.http.delete<any>(this.sharedService.apiUrl(`map/layer/feature/attributes/${id}`))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  deleteFeature$(id): Observable<any>{
    return this.http.delete<any>(this.sharedService.apiUrl(`map/layer/feature/${id}`))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  importShape$(shapeData): Promise<any> {

    const form = new FormData();
    form.append('shape', shapeData);

    return this.http.post(this.sharedService.apiUrl('map','shape2geojson'), form,
      {})
      .toPromise()
      .catch(error => this.sharedService.handleErrorPromise(error))
  }

  upsertFeature$(body, layerKey): Observable<any> {
    if (!body.id)
      return this.http.post<any>(this.sharedService.apiUrl(`map/layer/${layerKey}/feature`), body)
        .pipe(
          catchError(error => this.sharedService.handleError(error))
        );
    else
      return this.http.put<any>(this.sharedService.apiUrl(`map/layer/feature/${body.id}`), body)
        .pipe(
          catchError(error => this.sharedService.handleError(error))
        );
  }

  detectFeatureOnLayer$(layerKey, latlng): Observable<any> {
    return this.http.get(
      this.sharedService.apiUrl(`map/layer/${layerKey}/detect?lng=${latlng.lng}&lat=${latlng.lat}`))
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

  getAttributesFromShapeFile$(shapeFile): Promise<any>{
    const form = new FormData();
    form.append('shape', shapeFile);

    return this.http.post(this.sharedService.apiUrl('map/layer/attributes'), form,{})
      .toPromise()
      .catch(error => this.sharedService.handleErrorPromise(error))
  }

  uploadShapeFile$(layer, shapeFile, mappingBody): Promise<any> {
    const form = new FormData();
    form.append('shape', shapeFile);
    form.append('mapping', JSON.stringify(mappingBody.mapping))
    form.append('keyColumn', mappingBody.keyColumn)

    return this.http.post(this.sharedService.apiUrl(`map/layer/${layer}/upload`), form, {})
      .toPromise()
      .catch(error => this.sharedService.handleErrorPromise(error))
  }

  calculateArea$(geoJson){
    return this.http.post<any>(this.sharedService.apiUrl(`map/layer/feature/area`), {geoJson: geoJson})
      .pipe(
        catchError(error => this.sharedService.handleError(error))
      );
  }

}
